/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:12:50
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'PromotionInfoCard',

  props: ['subscriber'],
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/PromotionInfoCard/component.js